import { useCallback, useRef } from "react";
import clsx from "clsx";
import { cn } from "@/core/helpers/cn";
import { CrossIcon, SearchIcon } from "@/shared/icons";
import { TextInput } from "@/shared/ui";

type Props = {
  onChange: (value: string) => void;
  value: string;
  className?: string;
};

export default function InventorySearch({ onChange, value, className }: Props) {
  const ref = useRef(null);
  const clearInput = useCallback(() => {
    onChange("");
  }, [onChange]);

  return (
    <div className={cn("flex items-center gap-2 w-[8rem]", className)}>
      <SearchIcon size={16} className="shrink-0 text-white/50" />
      <TextInput
        ref={ref}
        value={value}
        onChange={onChange}
        inputClassName="bg-transparent h-[inherit] p-0"
        className="h-[1rem] text-15 font-medium"
        placeholder="Поиск"
      />

      <button type="button" onClick={clearInput} className={clsx({ invisible: !value })}>
        <CrossIcon size={14} className="text-accent-solid" />
      </button>
    </div>
  );
}
